import React from "react";
import PropTypes from "prop-types";

import "./NumberInput.scss";

function NumberInput({ id, label, unitLabel = "", value, onChange, minValue, maxValue, step = 1 }) {
  return (
    <div className="NumberInput form-group form-row">
      <label htmlFor={id} className="col-6 col-form-label">
        {label}
      </label>
      <div className="col-6 col-form-input">
        <div className="form-input">
          <input
            className="form-control"
            type="number"
            id={id}
            value={value}
            min={minValue}
            max={maxValue}
            step={step}
            onChange={(e) => onChange(id, parseInt(e.target.value))}
          />
        </div>
        <div className="form-label">
          <label htmlFor={id} className="NumberInput-label col-form-label">
            {unitLabel}
          </label>
        </div>
      </div>
    </div>
  );
}

NumberInput.propTypes = {
  id: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  unitLabel: PropTypes.string,
  value: PropTypes.number.isRequired,
  onChange: PropTypes.func.isRequired,
  minValue: PropTypes.number.isRequired,
  maxValue: PropTypes.number.isRequired,
  step: PropTypes.number,
};

export default NumberInput;
